import { render } from "./TreatmentPlan.vue?vue&type=template&id=caf01c9e&scoped=true"
import script from "./TreatmentPlan.vue?vue&type=script&lang=js"
export * from "./TreatmentPlan.vue?vue&type=script&lang=js"

import "./TreatmentPlan.vue?vue&type=style&index=0&id=caf01c9e&scoped=true&lang=sass"

import exportComponent from "/home/ploi/orthomatrix.orthosol.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-caf01c9e"]])

export default __exports__